import axios from "axios";
import { FormType } from "../components/Form/Form";
import { getAccounts } from "./data";

export type FormResponse = {
  ok: boolean;
  message: string;
  data?: any;
};

export const createAccount = async (data: FormType): Promise<FormResponse> => {
  const payload = {
    email: data.text,
    password: data.password,
  };
  return axios
    .post("http://localhost:8800/insert-account", payload)
    .then((res) => {
      console.log(res);
      return {
        ok: true,
        message: "Account created",
      } as FormResponse;
    })
    .catch((err) => {
      return {
        ok: false,
        message: "Error in creation of account",
      } as FormResponse;
    });
};

export const loginAccount = async (
  email: string,
  password: string
): Promise<FormResponse> => {
  return new Promise(async (res) => {
    const accounts = await getAccounts();
    const isPresent = !!accounts.find((item) => {
      return item.email === email && item.password === password;
    });
    const obj: FormResponse = {
      ok: isPresent,
      message: isPresent ? "Login perfectly" : "Not Logged in",
      data: {
        email,
        password,
      },
    };
    res(obj);
  });
};
